import React, { useState, useEffect } from "react";
import TableViewSearch from "../../CustomComponent/TableViewSearch";
import TableView from "../../CustomComponent/TableView";
import useStyles from "../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";
import { decryptData } from "../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function ViewRankWiseReport({ selectedExam, cources, column }) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [rowCount, setRowCount] = useState("");

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage);
  };

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editcource") {
      navigate(`/admin/editcource/${rowId}`);
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const rows = (cources || []).map((d, index) => {
    const row = { id: index + 1, srno: index + 1 };

    // Fill only the keys that are present in `column` prop
    Object.keys(column).forEach((key) => {
      row[key] = d[key] ?? "N/A";
    });

    return row;
  });

  // Filter rows by search query (across all column values)
  const filteredRows = rows.filter((row) =>
    Object.keys(column).some((key) =>
      String(row[key]).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const dynamicColumns = Object.entries(column).filter(([field, headerName])=>(headerName!=='Phone')).map(([field, headerName]) => ({
    field: field,
    headerName: headerName,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    // flex: 1,
    sortable: false,
    disableColumnMenu: true,
    autoPageSize: false,
    width: 200,
    renderCell: (params) => {
      // Special styling if this column is status
      if (field.toLowerCase() === "status") {
        return (
          <span
            style={{
              color: params.value === "Present" ? "green" : "red",
              fontWeight: 600,
            }}
          >
            {params.value}
          </span>
        );
      }

      if(headerName.includes('Marks') && !params.value ){ 
        return 0
      }

      return params.value || "N/A";
    },
  }));
  // Add serial number column at the beginning
  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 80,
      sortable: false,
      disableColumnMenu: true,
    },
    ...dynamicColumns,
  ];

  // const columns = [
  //   {
  //     field: "srno",
  //     headerName: "#",
  //     headerClassName: "super-app-theme--header",
  //     headerAlign: "center",
  //     width: 100,
  //     sortable: false,
  //     disableColumnMenu: true,
  //     autoPageSize: false,
  //   },
  //   {
  //     field: "roll_number",
  //     headerName: "Roll Number",
  //     headerClassName: "super-app-theme--header",
  //     headerAlign: "center",
  //     width: 110,
  //     flex: 1,
  //     sortable: false,
  //     disableColumnMenu: true,
  //     autoPageSize: false,
  //   },
  //   {
  //     field: "student_name",
  //     headerName: "STUDENT NAME",
  //     headerClassName: "super-app-theme--header",
  //     headerAlign: "center",
  //     width: 110,
  //     flex: 1,
  //     sortable: false,
  //     disableColumnMenu: true,
  //     autoPageSize: false,
  //   },
  //   {
  //     field: "phone",
  //     headerName: "PHONE",
  //     headerClassName: "super-app-theme--header",
  //     headerAlign: "center",
  //     width: 110,
  //     flex: 1,
  //     sortable: false,
  //     disableColumnMenu: true,
  //     autoPageSize: false,
  //   },
  //   // {
  //   //   field: "status",
  //   //   headerName: "STATUS",
  //   //   headerClassName: "super-app-theme--header",
  //   //   headerAlign: "center",
  //   //   width: 110,
  //   //   flex: 1,
  //   //   sortable: false,
  //   //   disableColumnMenu: true,
  //   //   autoPageSize: false,
  //   // },
  // ];

  const Heading = [
    {
      id: 1,
      inputplaceholder: "Search cource name",
      // export: "yes",
    },
  ];

  const style = [
    {
      height: "maxh60",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "client",
    },
  ];

  return (
    <>
      <ToastContainer />
      {filteredRows?.length > 0 && (
        <div
          className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
        >
          <TableViewSearch Heading={Heading} onSearch={handleSearch} />
          <TableView columns={columns} rows={filteredRows} Heading={style} />
        </div>
      )}
    </>
  );
}
export default ViewRankWiseReport;
